import { render, staticRenderFns } from "./BuyerInformationSection.vue?vue&type=template&id=6de0b672&scoped=true&"
import script from "./BuyerInformationSection.vue?vue&type=script&lang=js&"
export * from "./BuyerInformationSection.vue?vue&type=script&lang=js&"
import style0 from "./BuyerInformationSection.vue?vue&type=style&index=0&id=6de0b672&prod&lang=css&"
import style1 from "./BuyerInformationSection.vue?vue&type=style&index=1&id=6de0b672&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de0b672",
  null
  
)

export default component.exports